import { defaultLocale, negotiateLocale, resources } from "@websede/i18n";
import i18next from "i18next";
import { initReactI18next } from "react-i18next";

const initialLocale = negotiateLocale(typeof navigator === "undefined" ? [] : navigator.languages);

void i18next.use(initReactI18next).init({
  resources,
  lng: initialLocale,
  fallbackLng: defaultLocale,
  defaultNS: "common",
  interpolation: { escapeValue: false },
});

export { i18next };
